import React from 'react';
import { Alert, Platform, View } from 'react-native';
import { UserIdentity } from '@sapphicsavvy/business';

interface Props {
    identity?: UserIdentity;
}

export const AutoScrollingAvatars = ({ identity }: Props) => {
    return <View />;
};
